import { Plus } from "lucide-react";

const ITEMS = [
  "Ortopedia",
  "Clínica Médica",
  "Psiquiatria",
  "Psicologia",
  "Nutricionista",
  "Pilates",
  "Fisioterapia",
  "Drenagem Linfática",
  "Desde 2004",
  "Teresina • Zona Norte",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden bg-cob-dark py-5" aria-hidden="true">
    <div className="marquee-track flex w-max animate-marquee items-center">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-lg sm:text-xl italic tracking-wide text-white/85 px-8">
            {item}
          </span>
          <Plus className="h-3.5 w-3.5 text-cob-gold" />
        </span>
      ))}
    </div>
  </div>
);
